import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import pinia from './store'
import { setupStore } from "@/store";
import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import "./assets/styles/index.scss";

import login from './components/loginModal/index'


// import waterfall from 'vue-waterfall2'
// import vueWaterfallEasy from 'vue-waterfall-easy'

import "@/permission";

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)


setupStore(app);

app.config.globalProperties.$message = ElMessage;
//捕获错误
app.config.errorHandler = (error, vm, info) => {
  console.error(error, vm, info)
}

app.use(router).use(ElementPlus).use(login).mount('#app')

import { ElMessage } from 'element-plus'

ElMessage.error = (message) => {
    ElMessage({type: "info", message: message});
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
